module.exports = "::ng-deep tab.json_string ul ul {\n  padding-left: 20px; }\n\n:host {\n  max-width: 100% !important; }\n"